<template>
  <div class="ip-container">
    <header class="header">
      <div class="inner container">
        <div class="logo">
          <a href="">
            <img src="../../assets/logo.png" alt="" />
          </a>
        </div>
        <div class="menu">
          <a href="" class="menu-item">首页</a>
          <div href="" class="menu-item active">
            产品服务
            <ul class="sub-menu">
              <div class="arrow"></div>
              <li>
                <router-link target="_blank" to="/" class="sub-menu-item"
                  >广告监测</router-link
                >
              </li>
              <li>
                <router-link to="/ip" class="sub-menu-item"
                  >综合定位服务</router-link
                >
              </li>
            </ul>
          </div>
          <a
            href="https://www.admobile.top/aboutus.html"
            class="menu-item"
            target="_blank"
            >关于我们</a
          >
        </div>
        <div class="user" id="user">
          <div class="user-center">
            <router-link
              v-if="!isLogin"
              class="button button-light"
              id="login"
              :to="{ path: '/login' }"
              >登录</router-link
            >
            <div v-else class="user-info">
              <el-dropdown>
                <span class="el-dropdown-link">
                  {{ userInfo.username }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <!-- <span @click="showDialog = true">用户中心</span> -->
                    <router-link
                      to="/user"
                      style="text-decoration: none; color: #666"
                      >用户中心</router-link
                    >
                  </el-dropdown-item>
                  <el-dropdown-item divided>
                    <span @click="logout">退出</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </header>
    <router-view></router-view>
    <Footer></Footer>
    <div class="dialog" id="dialog" :class="{ show: showDialog }">
      <div class="inner">
        <div class="user-info section">
          <h3>用户中心</h3>
          <p>用户ID：1000114</p>
          <p>用户名：156****2008</p>
        </div>
        <div class="service-info section">
          <h3>我的服务</h3>

          <div v-for="service in services" :key="service.name">
            <h4>{{ service.name }}</h4>
            <p v-if="service.status == 0">
              <a
                href="https://wpa.qq.com/msgrd?v=3&uin=258620589&site=qq&menu=yes"
                target="_blank"
                >{{ service.msg }}</a
              >
            </p>
            <table v-else cellpadding="0" cellspacing="0">
              <tbody>
                <tr>
                  <td>服务</td>
                  <td>过期时间</td>
                  <td v-if="service.services[0].dosage">今日请求次数</td>
                </tr>
                <tr v-for="(item, index) in service.services" :key="index">
                  <td>{{ item.name }}</td>
                  <td>{{ item.expirydate }}</td>
                  <td v-if="item.dosage">
                    {{ item.dosage.dayNum }}/{{ item.dosage.dayLimit }}次
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="close" id="close" @click="showDialog = false">x</div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "../../components/Footer";
export default {
  name: "IpBase",
  components: { Footer },
  mounted() {
    console.log("ip服务加载中。。。");
    let session = this.$route.query["session"];
    if (!!session) {
      localStorage.setItem("session", session);
      localStorage.setItem("isLogin", "1");
    }
    this.session = localStorage.getItem("session");
    let isLogin = localStorage.getItem("isLogin");
    this.isLogin = isLogin;
    this.queryUserINfo();
  },
  data() {
    return {
      showDialog: false,
      isLogin: false,
      userInfo: {},
      services: [],
    };
  },
  methods: {
    queryUserINfo() {
      if (this.isLogin) {
        this.$http.get("/fireeye/account/details").then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code == 1) {
            this.userInfo = data.data;
            this.$root.status = this.userInfo.status;
            window.localStorage.setItem(
              "status",
              this.userInfo.status.toString()
            );
            this.services = data.data.serviceList;
          } else {
            console.log("获取用户信息失败");
          }
        });
      }
    },
    logout() {
      let session = localStorage.getItem("session");
      window.localStorage.removeItem("isLogin");
      window.localStorage.removeItem("session");
      this.$root.isLogin = false;
      this.isLogin = false;
      console.log(this.isLogin);
      let http = this.$http.create();
      http.defaults.headers.common["Content-Type"] =
        "application/x-www-form-urlencoded";
      http.post("/fireeye/account/logout?session=" + session).then((res) => {
        console.log(res);
        if (this.$route.path != "/") {
          this.$router.push("/login");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ip-container {
  background: linear-gradient(180deg, #05061b 0%, #00070e 100%);
}
.header {
  box-sizing: border-box;
  height: 80px;
  line-height: 80px;
}

.header .logo {
  line-height: 80px;
}

.header .logo img {
  vertical-align: middle;
  width: 180px;
  height: 50px;
}

.header .inner {
  display: flex;
}

.header .inner .menu {
  flex: 1;
  padding-left: 50px;
}

.header .inner .menu .menu-item {
  cursor: pointer;
  text-decoration: none;
  color: #fff;
  display: inline-block;
  padding: 0 24px;
  position: relative;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
}

.header .inner .menu .menu-item.active {
  color: #e98652;
}

.header .inner .menu .sub-menu {
  position: absolute;
  left: -8px;
  top: 40px;
  display: none;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 16px;
  font-weight: normal;
  width: 140px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 20px #999;
}

.header .inner .menu .sub-menu .arrow {
  width: 0;
  height: 0;
  border: 10px solid #fff;
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  position: absolute;
  top: -18px;
  left: 58px;
}

.header .inner .menu .sub-menu li {
  line-height: 50px;
}

.header .inner .menu .sub-menu-item {
  text-decoration: none;
  padding: 10px 16px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
}

.header .inner .menu .sub-menu-item:hover {
  text-decoration: none;
  padding: 10px 16px;
  color: #666;
}

.header .inner .menu .menu-item:hover {
  color: #666;
}

.header .inner .menu .menu-item:hover > .sub-menu {
  display: block;
}

/* 用户信息 */

.user {
  cursor: pointer;
}

/* 用户中心  */

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: none;
}

.dialog.show {
  display: block;
}

.dialog .inner {
  width: 600px;
  padding: 60px 80px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 15px #999;
}

.dialog .close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  border: 1px solid #ddd;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
  line-height: 20px;
}

.dialog table {
  border: 1px solid #333;
}

.dialog table td {
  padding: 10px 16px;
  border: 1px solid #333;
  text-align: center;
}

/* footer */

.footer {
  overflow: hidden;
  background-color: #05061b;
  font-family: PingFangSC-Medium, PingFang SC;
}

.footer .row {
  display: flex;
}

.footer .row .col-left {
  width: 600px;
}

.footer .row .col-right {
  flex: 1;
}

.footer-logo {
  width: 250px;
  height: 70px;
  margin: 32px auto 0;
}

.footer-title {
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
}

.footer .title {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  line-height: 22px;
  margin: 46px 0 24px 0;
}

.footer .nav {
  text-align: left;
}

.footer .nav-link,
.footer .info {
  display: block;
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  margin-bottom: 16px;
}

.footer .info {
  margin-bottom: 16px;
}

.footer .site-info {
  font-weight: 400;
  text-align: center;
  margin: 80px auto 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #ffffff;
  line-height: 20px;
}

.footer .site-info a {
  text-decoration: none;
  color: #ffffff;
}
</style>